// stores/store.js
import { defineStore } from "pinia";
import cookies from "js-cookie";
import api from "@/services/api";

export const useMainStore = defineStore("store", {
  state: () => {
    return {
      user: {
        id: 0,
        first_name: "",
        last_name: "",
        email: "",
        language: "en",
        email_verified_at: null,
        created_at: null,
        updated_at: null,
        is_staff: false,
        active_app_id: null,
        active_workspace_id: null
      },
      workspaces: [],
      workspace: {},
      isLoadingWorkspaces: false,
      kyano: {
        version: "0.0.1",
        name: "Kyano",
        description: "Kyano is a platform for managing your business",
        logo: "https://cdn.kyano.app/img/kyano-logo-dark.svg",
        url: "https://kyano.app",
        support: "",
        terms_url: "https://policies.kyano.app/terms",
        privacy_url: "https://policies.kyano.app/privacy"
      },
      ticketSettings: {},
      loadingSettings: false
    };
  },
  actions: {
    setUser(user) {
      this.user = user;
    },

    setWorkspaces(workspaces) {
      this.workspaces = workspaces;
    },

    setActiveAppId(appId) {
      this.user.active_app_id = appId;
    },

    setActiveWorkspaceId(workspaceId) {
      this.user.active_workspace_id = workspaceId;
    },

    async fetchWorkspaces() {
      this.isLoadingWorkspaces = true;
      try {
        const response = await api.get("/api/v1/workspaces"); // Stel dit in naar de juiste API-route
        this.workspaces = response.data; // Zorg ervoor dat de response.data de werkruimtes is
      } catch (error) {
        console.error("Fout bij ophalen van werkruimtes:", error);
      }
      this.isLoadingWorkspaces = false;
    },

    async fetchTicketSettings() {
      this.loadingSettings = true;
      try {
        const response = await api.get("/api/v1/ticket-settings");
        this.ticketSettings = response.data.data;
      } catch (error) {
        console.error("Fout bij ophalen ticketinstellingen:", error);
      } finally {
        this.loadingSettings = false;
      }
    },

    async fetchActiveWorkspace() {
      // Optional: fetch single workspace via dedicated endpoint
      try {
        const response = await api.get("/api/v1/workspace-current");
        // { message, workspace, subscription, success }
        this.workspace = response.data.workspace || {};
      } catch (error) {
        console.error("Fout bij ophalen actieve workspace:", error);
        this.workspace = {};
      }
    },

    async updateTicketSettings(updatedSettings) {
      this.loadingSettings = true;
      try {
        const response = await api.put(
          "/api/v1/ticket-settings",
          updatedSettings
        );
        this.ticketSettings = response.data.data; // Update de instellingen in de store
      } catch (error) {
        console.error("Fout bij het bijwerken van ticketinstellingen:", error);
      } finally {
        this.loadingSettings = false;
      }
    },
    logout() {
      cookies.remove("kyano_access_token");
      cookies.remove("kyano_user");
      location.replace(config.url.main);
    }
  },
  getters: {
    isUserStaff: state => state.user.is_staff,
    workspaceId: state => state.user.active_workspace_id,
    getActiveAppId: state => state.user.active_app_id,
    getActiveSubscription: state => state.workspace.active_subscription || {},
    getTicketSettings: state => state.ticketSettings,
    isLoadingSettings: state => state.loadingSettings
  }
});
